import { Box, styled } from '@mui/material';
import {
  chromeYellow, kiwiGreen, sanguine, spaceCadet, ultraMarine,
} from '../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  padding: '4px 8px',
  fontSize: 12,
  lineHeight: '14px',
  gap: 4,
  borderRadius: 4,
  fontWeight: 600,
  maxWidth: 'max-content',

  '&.Pending': {
    backgroundColor: ultraMarine[500],
    color: ultraMarine[100],
  },

  '&.Done': {
    backgroundColor: kiwiGreen[700],
    color: kiwiGreen[100],
  },

  '&.InProgress': {
    backgroundColor: chromeYellow[600],
    color: ultraMarine[100],
  },

  '&.Cancelled': {
    backgroundColor: spaceCadet[400],
    color: spaceCadet[800],
  },

  '&.Denied': {
    backgroundColor: sanguine[100],
    color: sanguine[600],
  },
});

export default StyledBox;
